module.exports = __webpack_public_path__ + "static/media/40.3f0e1437.png";